export const kpis = {
  totalSpend: "$14.2M",
  spendTrend: "+8.4%",
  activeVendors: 142,
  highRisk: 7,
  expiring30Days: 12
};

export const vendors = [
  { 
    id: 'V001', 
    name: 'CyberShield Systems', 
    category: 'IT Security', 
    risk: 'High', 
    spend: '$450k', 
    status: 'Active', 
    value: 85, 
    riskScore: 80,
    notes: 'Last security audit failed on SOC2 compliance. Remediation in progress.',
    lastReview: '2023-11-15'
  },
  { 
    id: 'V002', 
    name: 'Global Logistics Co.', 
    category: 'Supply Chain', 
    risk: 'Medium', 
    spend: '$2.1M', 
    status: 'Active', 
    value: 60, 
    riskScore: 45,
    notes: 'SLA uptime at 98.2%. Slightly below the 99% target.',
    lastReview: '2024-01-10'
  },
  { 
    id: 'V003', 
    name: 'CloudNet Infrastructure', 
    category: 'SaaS', 
    risk: 'Low', 
    spend: '$1.2M', 
    status: 'Active', 
    value: 95, 
    riskScore: 20,
    notes: 'Primary cloud provider. Performance exceeds all KPIs.',
    lastReview: '2024-02-01'
  },
  { 
    id: 'V004', 
    name: 'Apex Marketing', 
    category: 'Agency', 
    risk: 'Medium', 
    spend: '$300k', 
    status: 'Under Review', 
    value: 40, 
    riskScore: 50,
    notes: 'Contract renewal pending budget approval from CMO.',
    lastReview: '2023-12-20'
  },
  { 
    id: 'V005', 
    name: 'Nexus Legal Group', 
    category: 'Services', 
    risk: 'Low', 
    spend: '$850k', 
    status: 'Active', 
    value: 70, 
    riskScore: 10,
    notes: 'Internal legal counsel. High strategic importance.',
    lastReview: '2024-01-25'
  },
  { 
    id: 'V006', 
    name: 'Quantum Data', 
    category: 'Analytics', 
    risk: 'High', 
    spend: '$120k', 
    status: 'Onboarding', 
    value: 55, 
    riskScore: 75,
    notes: 'Awaiting final security sign-off for PII data processing.',
    lastReview: 'N/A'
  },
];

export const contracts = [
  { id: 'C101', vendor: 'CloudNet Infrastructure', type: 'Enterprise MSA', expiry: 12, value: '$1.2M', status: 'critical' },
  { id: 'C102', vendor: 'CyberShield Systems', type: 'Annual License', expiry: 28, value: '$450k', status: 'warning' },
  { id: 'C103', vendor: 'Global Logistics Co.', type: 'Service Level Agreement', expiry: 45, value: '$2.1M', status: 'safe' },
  { id: 'C104', vendor: 'Nexus Legal Group', type: 'Retainer', expiry: 80, value: '$850k', status: 'safe' },
  { id: 'C105', vendor: 'DataFlow Inc.', type: 'API Access', expiry: 5, value: '$45k', status: 'critical' },
];

export const approvals = [
  { id: 'A001', vendor: 'Quantum Data', task: 'New Vendor Onboarding', submittedBy: 'Sarah Jenkins', date: '2h ago', status: 'pending' },
  { id: 'A002', vendor: 'Apex Marketing', task: 'Contract Renewal', submittedBy: 'Mike Ross', date: '1d ago', status: 'pending' },
  { id: 'A003', vendor: 'SysOps Pro', task: 'Security Compliance Check', submittedBy: 'IT Dept', date: '2d ago', status: 'pending' },
];

export const spendData = {
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  values: [0.8, 0.9, 1.1, 1.0, 1.2, 1.4, 1.3, 1.5, 1.7, 1.6, 1.8, 2.1]
};

export const faqs = [
  {
    q: "How is the Vendor Risk Score calculated?",
    a: "Our proprietary algorithm aggregates data from 4 key pillars: Financial Stability, Operational Uptime (SLA), Security Compliance (SOC2/ISO), and Geo-political/Supply Chain factors. Scores above 70 are flagged as High Risk."
  },
  {
    q: "Can I import data from my existing ERP or CLM?",
    a: "Yes. VendorVista provides pre-built connectors for SAP, Oracle, and Coupa. You can also upload CSV/Excel files directly into the Vendor Directory for bulk processing."
  },
  {
    q: "Is the dummy data in this demo private?",
    a: "No. All data shown in this demo environment is entirely synthetic and intended for demonstration purposes only. No real vendor or financial information is used."
  },
  {
    q: "How do Renewal Lanes work?",
    a: "Renewal Lanes automatically categorize your contracts based on their expiration date. They provide a visual Kanban board to help procurement teams prioritize negotiations before auto-renewal clauses kick in."
  },
  {
    q: "What support options are available for the Pro plan?",
    a: "Pro plan users receive 24/7 priority email and chat support, a dedicated Customer Success Manager, and quarterly vendor strategy reviews."
  }
];